/* eslint-disable no-unused-vars */

import React from "react";
import ReactGA from "react-ga4";

import { Grid, useMediaQuery } from "@mui/material";
import { Typography } from "design_system/src";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  clearApplicationLoanTime,
  clearApplicationVehicle,
  clearApplicationSku,
} from "store/actions/application";
import CardSku from "components/cards/CardSku";
import { TSku } from "../../models/inventory/interfaces/sku.interface";

import NoResultImage from "../../static/images/noResult.png";

type OzonPaginationProps = {
  skus: TSku[];
};

const NoResult = () => {
  return (
    <div
      style={{
        height: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginRight: "20%",
        padding: "10%",
        textAlign: "center",
      }}
    >
      <img height="100" src={NoResultImage} alt="noResult" />
      <Typography weight="400" scale="medium">
        No hay resultados con los citerios de búsqueda
      </Typography>
    </div>
  );
};

const OzonCardVehiclesPagination: React.FC<OzonPaginationProps> = ({
  skus,
}) => {
  const matchesXS = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const triggerCard = () => {
    ReactGA.event("CTA_catalog_help_card", {
      category: "Marketplace",
      label: "click on the help card in the catalog",
    });
    navigate("/financia-tu-moto");
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationSku());
  };

  return skus.length === 0 ? (
    <NoResult />
  ) : (
    <Grid
      container
      rowSpacing={!matchesXS ? 2 : 3}
      columnSpacing={!matchesXS ? 0 : 2}
    >
      {skus
        .map((sku, idx) => {
          return (
            <Grid
              key={`VehicleCardContainer-${idx}`}
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              xl={3}
              style={{ minHeight: "100%" }}
            >
              <CardSku
                isHelperCard={sku === null}
                sku={sku}
                triggerCard={triggerCard}
              />
            </Grid>
          );
        })}
    </Grid>
  );
};

export default OzonCardVehiclesPagination;
